import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import gql from 'graphql-tag';

//Material
import makeStyles from '@material-ui/core/styles/makeStyles';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';

//ICONS
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TableChartOutlinedIcon from '@material-ui/icons/TableChartOutlined';
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined';
import GetAppIcon from '@material-ui/icons/GetApp';

//DS
import { useApolloLazyQ, useCsv } from '../../../hooks';
import SelectDS from '../../atomicos/SelectDS';
import LoadingModal from '../../moleculas/LoadingModal';
import BandaDatos from './BandaDatos';
import Fila from './vistaTabla/Fila';
import Celda from './vistaTabla/Celda';
import Campo from './vistaCard/Campo';
import Card from './vistaCard/Card';

//DEFAULTS
import { validacion, defaults } from 'lib.common';
const { funcionVacia } = defaults;
const { esVarNullUndef } = validacion;

const queryDefault = gql`
   query getData {
      getData {
         data
      }
   }
`;

const useStyles = makeStyles(theme => ({
   expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
         duration: theme.transitions.duration.shortest
      })
   },
   expandOpen: {
      transform: 'rotate(180deg)'
   },
   classContainer: {
      backgroundColor: theme.palette.primary.dark
   },
   full: {
      width: '100%'
   },
   nroRegistros: {
      minWidth: '9rem'
   }
}));

function FmReporte(props) {
   const classes = useStyles();
   //Desestructurar propiedades
   const {
      data,
      query,
      callbacksQuery,
      titulo,
      campos,
      vista,
      contenedor,
      registro,
      campo,
      resumen,
      genParametrosQuery,
      inicializarFormulario,
      children,
      mostrarMensajeError
   } = props;

   //----- CSV -----
   const [exportarCsv, { procesando, filaActual }] = useCsv();

   function exportar() {
      if (dataReporte && dataReporte.length > 0) {
         exportarCsv(dataReporte, {
            nombreArchivo: `${titulo}-${new Date().getTime().toString()}`,
            descargarAlFinalizar: true,
            columnas: campos
         });
      }
   }
   function normalizarNroFilaProcesada(value) {
      return ((value - 0) * 100) / (dataReporte.length - 0);
   }
   //----- ENDCSV -----
   const [vistaElegida, setVistaElegida] = useState(vista || 'tabla');

   function handleRadioChange(event) {
      setVistaElegida(event.target.value);
   }

   const [dataReporte, setDataReporte] = useState(data);

   const [pagina, setPagina] = useState(1);
   function handleChangePagina(event, value) {
      setPagina(value);
   }

   const [nroPaginas, setNroPaginas] = useState(0);
   const [elementosPorPagina, setElementosPorPagina] = useState(props.defaultElementosPorPagina);
   function handleChangeElementosPorPagina(e) {
      const nuevoValor = e.target.value;
      setElementosPorPagina(nuevoValor);
   }

   const [expanded, setExpanded] = useState(true);
   const [expandedAvanzado, setExpandedAvanzado] = useState(false);
   function handleExpandClick() {
      setExpanded(!expanded);
   }
   useEffect(() => {
      if (elementosPorPagina === -1 || esVarNullUndef(dataReporte)) {
         setNroPaginas(0);
      } else {
         setNroPaginas(Math.ceil(dataReporte.length / elementosPorPagina));
      }
   }, [elementosPorPagina]);

   function toggleAvanzado() {
      setExpandedAvanzado(!expandedAvanzado);
   }

   const queryRecuperar = query || queryDefault;

   const [getData, { data: dataQ, loading }] = useApolloLazyQ(queryRecuperar, callbacksQuery);

   let BandaDatosProps = {
      nroRegistrosMostrar: elementosPorPagina,
      offset: (pagina - 1) * elementosPorPagina,
      registros: dataReporte,
      campos
   };

   let contenedorProps = contenedor ? contenedor.props : {};

   async function esInputOk() {
      let resultado = {
         ok: false,
         msg:
            'Ha sucedido un error al momento de validar los datos.\nPor favor verifique que la información ingresada sea correcta'
      };
      if (typeof props.existeErrorInput !== 'undefined') {
         if (!props.existeErrorInput && props.validarInput !== undefined) {
            resultado.ok = await props.validarInput();
            return resultado;
         } else {
            resultado.ok = !props.existeErrorInput;
            return resultado;
         }
      }
      if (props.esInputOk) {
         return await props.esInputOk();
      }
      resultado.ok = true;
      resultado.msg = '';
      return resultado;
   }

   useEffect(() => {
      if (dataQ !== null && dataQ !== undefined) {
         setDataReporte(dataQ[Object.keys(dataQ)[0]]);
         setNroPaginas(Math.ceil(dataQ[Object.keys(dataQ)[0]].length / elementosPorPagina));
         toggleAvanzado();
      }
   }, [dataQ]);

   async function procesarConsulta() {
      if (data === undefined) {
         const input = await esInputOk();
         if (input.ok) {
            if (genParametrosQuery) {
               const parametros = await genParametrosQuery();
               getData({ variables: parametros });
            } else {
               getData();
            }
            handleExpandClick();
         } else {
            mostrarMensajeError(input.msg);
         }
      }
   }

   function inicializar() {
      setDataReporte(data);
      setPagina(1);
      setNroPaginas(0);
      setElementosPorPagina(props.defaultElementosPorPagina);
      setExpanded(true);
      setExpandedAvanzado(false);
      inicializarFormulario();
   }

   function renderSwitch() {
      switch (vistaElegida) {
         case 'tabla':
            BandaDatosProps.registro = {
               componente: Fila
            };
            BandaDatosProps.campo = {
               componente: Celda
            };
            if (registro) {
               BandaDatosProps.registro.props = registro.props;
               if (registro.componente) {
                  BandaDatosProps.registro.componente = registro.componente;
               }
            }
            if (campo) {
               BandaDatosProps.campo.props = campo.props;
               if (campo.componente) {
                  BandaDatosProps.campo.componente = campo.componente;
               }
            }
            return (
               <TableContainer component={Paper}>
                  <Table {...contenedorProps}>
                     <TableHead>
                        <TableRow>
                           {campos.map((item, index) => {
                              return <TableCell key={index}>{item.titulo}</TableCell>;
                           })}
                        </TableRow>
                     </TableHead>
                     <TableBody>
                        <BandaDatos {...BandaDatosProps} />
                     </TableBody>
                  </Table>
               </TableContainer>
            );
         case 'card':
            BandaDatosProps.registro = {
               componente: Card
            };
            BandaDatosProps.campo = {
               componente: Campo
            };
            if (registro) {
               BandaDatosProps.registro.props = registro.props;
            }
            if (campo) {
               BandaDatosProps.campo.props = campo.props;
            }

            const { spacing, className, ...otrosContenedorProps } = contenedorProps;
            return (
               <Grid
                  container
                  className={clsx(classes.cardContainer, className)}
                  spacing={spacing || 2}
                  {...otrosContenedorProps}
               >
                  <BandaDatos {...BandaDatosProps} />
               </Grid>
            );
      }
   }

   return (
      <Grid container item xs={12} spacing={3}>
         <Grid
            component={Paper}
            container
            item
            xs={12}
            justify="center"
            alignItems="center"
            alignContent="center"
            style={{ marginTop: '20px' }}
         >
            <Grid container item xs={10} alignItems="center">
               <Typography variant="h4" gutterBottom>
                  {titulo.toUpperCase()}
               </Typography>
            </Grid>
            <Grid container item xs={2} justify="flex-end">
               <IconButton
                  className={clsx(classes.expand, {
                     [classes.expandOpen]: expanded
                  })}
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="show more"
                  size="small"
               >
                  <ExpandMoreIcon />
               </IconButton>
            </Grid>
            <Grid container item xs={12}>
               <Collapse in={expanded} timeout="auto" className={classes.full}>
                  <Grid container>
                     <Grid container item xs={12} spacing={1}>
                        {children}
                     </Grid>
                     <Grid container item xs={12} alignItems="flex-end">
                        <Button
                           style={{ marginRight: '5px' }}
                           color="primary"
                           variant="contained"
                           onClick={procesarConsulta}
                        >
                           Consultar
                        </Button>
                        <Button color="primary" variant="contained" onClick={inicializar}>
                           Limpiar
                        </Button>
                     </Grid>
                  </Grid>
               </Collapse>
            </Grid>
         </Grid>
         <Grid component={Paper} container item xs={12}>
            <Grid container item xs={12} spacing={0}>
               <Grid container item xs={10} spacing={0}>
                  <Button
                     onClick={toggleAvanzado}
                     endIcon={
                        <ExpandMoreIcon
                           className={clsx(classes.expand, {
                              [classes.expandOpen]: expandedAvanzado
                           })}
                        />
                     }
                     fullWidth
                  >
                     Opciones Avanzadas
                  </Button>
               </Grid>
               <Grid container item xs={2} spacing={0}>
                  <FormControl component="fieldset">
                     <RadioGroup
                        aria-label="vistas"
                        name="vistas"
                        value={vistaElegida}
                        onChange={handleRadioChange}
                        row
                     >
                        <Tooltip title="Vista Tabla" placement="top">
                           <Radio
                              value="tabla"
                              icon={<TableChartOutlinedIcon />}
                              checkedIcon={<TableChartOutlinedIcon />}
                           />
                        </Tooltip>
                        <Tooltip title="Vista Card" placement="top">
                           <Radio
                              value="card"
                              icon={<PaymentOutlinedIcon />}
                              checkedIcon={<PaymentOutlinedIcon />}
                           />
                        </Tooltip>
                     </RadioGroup>
                  </FormControl>
               </Grid>
            </Grid>
            <Collapse in={expandedAvanzado} timeout="auto" className={classes.full}>
               <Grid container>
                  <Grid container item xs={10} alignItems="center">
                     <SelectDS
                        label="Registros por página:"
                        data={[10, 25, 50, 100, -1]}
                        value={elementosPorPagina}
                        onChange={handleChangeElementosPorPagina}
                        variant="outlined"
                        margin="dense"
                        genItemLabel={item => {
                           if (item === -1) {
                              return 'Todos';
                           } else {
                              return item;
                           }
                        }}
                        className={classes.nroRegistros}
                     />
                     <Pagination
                        page={pagina}
                        onChange={handleChangePagina}
                        count={nroPaginas}
                        variant="outlined"
                        shape="rounded"
                        showFirstButton
                        showLastButton
                     />
                  </Grid>
                  <Grid container item xs={1} spacing={0}>
                     <Tooltip title="Exportar a CSV" placement="top">
                        <IconButton size="small" aria-label="export-csv" onClick={exportar}>
                           <GetAppIcon />
                        </IconButton>
                     </Tooltip>
                  </Grid>
                  {/*procesando && (
                     <Grid container item xs={12} spacing={0}>
                        <Grid item xs={9}>
                           <ProgressBar value={normalizarNroFilaProcesada(filaActual)} />
                        </Grid>
                        <Grid item xs={3}>
                           <Typography
                              variant="body2"
                              color="textSecondary"
                           >{`Exportados ${filaActual} de ${dataReporte.length} registros.`}</Typography>
                        </Grid>
                     </Grid>
                  )*/}
               </Grid>
            </Collapse>
         </Grid>
         <Grid container item xs={12}>
            {dataReporte !== null && dataReporte !== undefined && renderSwitch()}
         </Grid>
         <LoadingModal open={loading} />
      </Grid>
   );
}
FmReporte.protoTypes = {
   data: PropTypes.arrayOf(PropTypes.object),
   query: PropTypes.string,
   callbacksQuery: PropTypes.shape({
      callbackProcesarData: PropTypes.func,
      callbackError: PropTypes.func,
      callbackLoading: PropTypes.func
   }),
   titulo: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
   campos: PropTypes.arrayOf(
      PropTypes.shape({
         nombre: PropTypes.string.isRequired,
         titulo: PropTypes.string,
         valorMostrar: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
         valorNullMostrar: PropTypes.string,
         funcionResumen: PropTypes.oneOfType([
            PropTypes.oneOf(['suma', 'max', 'min']),
            PropTypes.func
         ]),
         valorResumen: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
         valorNullResumen: PropTypes.any,
         oculto: PropTypes.bool,
         props: PropTypes.object
      })
   ).isRequired,
   vista: PropTypes.oneOf(['tabla', 'card', 'personalizado']),
   cabeceraReporte: PropTypes.shape({
      componente: PropTypes.elementType,
      props: PropTypes.object
   }),
   contenedor: PropTypes.shape({
      componente: PropTypes.elementType,
      props: PropTypes.object
   }),
   registro: PropTypes.shape({
      componente: PropTypes.elementType,
      props: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
   }),
   campo: PropTypes.shape({
      componente: PropTypes.elementType,
      props: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
   }),
   resumen: PropTypes.shape({
      componente: PropTypes.elementType,
      props: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
   }),
   genParametrosQuery: PropTypes.func,
   /**
    * Representa si existe algun error en los estados del input. Si es verdadero significa un error en los estados del input y bloquea la opcion de consulta.
    */
   existeErrorInput: PropTypes.bool,
   /**
    * Funcion de verificacion personalizada del input, toma precedencia sobre existeErrorInput. No acepta parametros, debe retornar un objeto con la forma {ok: boolean, msg: string} donde msg representa el mensaje de error a mostrar y si ok es false significa que existe un error en el input.
    */
   validarInput: PropTypes.func,
   defaultElementosPorPagina: PropTypes.oneOf([10, 25, 50, 100, -1]),
   inicializarFormulario: PropTypes.func,
   /**
    * Funcion llamada para mostrar mensajes de exito, toma como parametro el mensaje generado.
    */
   mostrarMensajeExito: PropTypes.func,
   /**
    * Funcion llamada para mostrar mensajes de error, toma como parametro el mensaje generado.
    */
   mostrarMensajeError: PropTypes.func
};
FmReporte.defaultProps = {
   vista: 'tabla',
   defaultElementosPorPagina: -1,
   mostrarMensajeExito: funcionVacia,
   mostrarMensajeError: funcionVacia,
};
export default FmReporte;
